/**
 * Created by atarara on 11.04.2017.
 */

export class TreeUtil{
    // Рекурсивный поиск
    static getSubMenuItem(subMenuItems, id) {
        if (subMenuItems) {
            for (var i = 0; i < subMenuItems.length; i++) {
                if (subMenuItems[i].id == id) {
                    return subMenuItems[i];
                }
                var found = this.getSubMenuItem(subMenuItems[i].children, id);
                if (found) return found;
            }
        }
    }

    static setActiveWithChildrens(node):any{
        node.data.isChoose = !node.data.isChoose;
        if(node.hasChildren){

        }
    }
}
